module.exports = __webpack_public_path__ + "media/images/guideline/coupon-04-5935cd6ac0fc296cefd665fe7fd906c8.jpg";